import { BaseCommand } from "@crunchdao/shared-cli";
import { formatCrunch, parseCrunch, StakingClient } from "@crunchdao/sdk";
import { PublicKey } from "@solana/web3.js";

export class DelegateCommand extends BaseCommand {
  async execute(coordinator: PublicKey, amount: number): Promise<void> {
    try {
      const formattedAmount = formatCrunch(parseCrunch(amount));
      this.displayAction(`Delegating ${formattedAmount} CRNCH to ${coordinator.toBase58()}`);

      const stakingClient = new StakingClient({
        connection: this.provider.connection,
        wallet: this.provider.wallet,
      });

      const amountBigInt = parseCrunch(amount);
      const signature = await stakingClient.stakeToCoordinator(coordinator, amountBigInt);

      this.displayActionComplete(`Delegated ${formattedAmount} CRNCH`);
      console.log(`Transaction: ${signature}`);
    } catch (error) {
      console.error("❌ Error delegating tokens:", error);
      throw error;
    }
  }
}
